module.exports = __webpack_public_path__ + "img/Gavagai.739770f8.png";